import React from 'react';
import {Route, Switch} from 'react-router-dom';
import {Media} from 'src/utils/Media';
import InboxMenu from './inboxMenu';
import Conversation from './conversation';
import ConversationList from './conversationList';
import ConversationHeader from './conversationHeader';
import InputBar from './inputBar';

import './chat.css';
import './inboxLayout.css';

const Column = ({span, children, className = '', style}) => (
  <div className={`br-inbox-col br-inbox-col--${span} ${className}`.trim()}
    style={style}>{children}</div>
);

const MessageInbox = ({match}) => (
  <div className='br-inbox-layout'>
    <div className='br-inbox-row'>
      <Media greaterThan='tablet'>
        {(_className, renderChildren) => renderChildren && (
          <Column span={4}>
            <Route path={match.path}><InboxMenu newMessageButton /></Route>
          </Column>
        )}
      </Media>
      <Media at='tablet'>
        {(_className, renderChildren) => renderChildren && (
          <Column span={4}>
            <Route path={match.path}><InboxMenu newMessageButton /></Route>
          </Column>
        )}
      </Media>
      <Media at='mobile'>
        {(_className, renderChildren) => renderChildren && (
          <Column span={2}>
            <Switch>
              <Route path={`${match.path}/conversations/:conversationId`}>
                <InboxMenu backButton />
              </Route>
              <Route path={`${match.path}/`}>
                <InboxMenu newMessageButton />
              </Route>
            </Switch>
          </Column>
        )}
      </Media>
      <Media at='mobile'>
        {(_className, renderChildren) => renderChildren && (
          <Column span={14}>
            <Route path={`${match.path}/conversations/:conversationId`}>
              <ConversationHeader />
            </Route>
          </Column>
        )}
      </Media>
      <Media greaterThan='mobile'>
        {(_className, renderChildren) => renderChildren && (
          <Column span={12}>
            <Route path={`${match.path}/conversations/:conversationId`}>
              <ConversationHeader />
            </Route>
          </Column>
        )}
      </Media>
    </div>
    <hr className='br-inbox-divider' />
    <div className='br-inbox-row br-inbox-row--content'>
      <Media greaterThan='tablet'>
        {(_className, renderChildren) => renderChildren && (
          <Column span={4} className='scrollable-container'
            style={{height: '82vh'}}>
            <Route path={match.path} component={ConversationList} />
          </Column>
        )}
      </Media>
      <Media greaterThan='tablet'>
        {(_className, renderChildren) => renderChildren && (
          <Column span={12}>
            <div id='message-list-scrollable' className='scrollable-container'
              style={{height: '70vh'}}>
              <Switch>
                <Route path={`${match.path}/conversations/:conversationId`}>
                  <Conversation />
                </Route>
                <Route path={match.path}><Conversation /></Route>
              </Switch>
            </div>
            <InputBar key='inputbar' />
          </Column>
        )}
      </Media>
      <Media at='tablet'>
        {(_className, renderChildren) => renderChildren && (
          <Column span={3} className='scrollable-container'
            style={{display: 'flex', height: '65vh'}}>
            <ConversationList collapsed />
          </Column>
        )}
      </Media>
      <Media at='tablet'>
        {(_className, renderChildren) => renderChildren && (
          <Column span={13}>
            <div id='message-list-scrollable' className='scrollable-container'
              style={{height: '65vh'}}>
              <Switch>
                <Route path={`${match.path}/conversations/:conversationId`}
                  component={Conversation} />
                <Route path={`${match.path}/`} component={Conversation} />
              </Switch>
            </div>
            <InputBar key='inputbar' />
          </Column>
        )}
      </Media>
      <Media at='mobile'>
        {(_className, renderChildren) => renderChildren && (
          <Column span={16}>
            <div id='message-list-scrollable' className='scrollable-container'
              style={{height: '65vh'}}>
              <Switch>
                <Route path={`${match.path}/conversations/:conversationId`}
                  component={Conversation} />
                <Route path={`${match.path}/`} component={ConversationList} />
              </Switch>
            </div>
            <InputBar key='inputbar' />
          </Column>
        )}
      </Media>
    </div>
  </div>
);

export default MessageInbox;
